<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            {{ $t('payment') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-card class="__card-online-order va-card">
          <v-card-text class="flex-column font-16">
            <div v-if="isTMII" class="d-flex mb-1">
              <div class="font-20 font-weight-bold black--text">
                {{ $store.state.selected_outlet.name }}
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex">
                {{ $t('order_number') }}
              </div>
              <v-spacer />
              <div class="d-flex font-weight-bold">
                {{ order.order_no }}
              </div>
            </div>
            <div class="d-flex black--text">
              <div class="d-flex">
                Total
              </div>
              <v-spacer />
              <div v-mask-money="order.total_amount" class="d-flex font-weight-bold" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-card v-if="order.payment_log" class="__card-online-order va-card">
          <div class="va-card-bank">
            <div class="va-icon">
              <img :src="order.payment_log.payment_image" alt="">
            </div>
            <div class="va-content">
              <div class="va-card-title">
                {{ order.payment_log.va_name }}
              </div>
              <div v-if="formattedTimeLeft !== 'EXPIRED'" class="va-card-number">
                {{ order.payment_log.va_account_number }}
                <input id="va_account_number" type="hidden" :value="order.payment_log.va_account_number">
                <v-btn class="ml-2" text icon color="primary" @click="copyText()">
                  <v-icon small>
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </div>
              <span>
                {{ $t('copy_number') }}
              </span>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-card v-if="order.payment_log" class="__card-expiry-va">
          <div class="expiry-va">
            <div class="expiry-title">
              {{ $t('payment_time_left') }}
            </div>
            <div class="expiry-content text-right">
              <span class="__expired">
                {{ formattedTimeLeft }}
              </span>
              <span class="time-expiry">
                {{ order.payment_log.expired_at }}
              </span>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-card class="__card-online-order">
          <div class="pa-4">
            <h4 class="title-va">
              {{ $t('payment_guide') }}
            </h4>
            <v-divider />
            <v-expansion-panels v-if="!$isEmpty(order.payment_log) && order.payment_log.va_bank_code !== ''" flat class="panel-guide">
              <template v-if="order.payment_log.va_bank_code === 'MANDIRI' || order.payment_log.va_bank_code === 'mandiri'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('mandiri_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Mobile Banking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('mandiri_mobile_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Internet Banking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('mandiri_internet_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-if="order.payment_log.va_bank_code === 'BNI' || order.payment_log.va_bank_code === 'bni'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bni_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Mobile Banking BNI
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bni_mobile_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Internet Banking BNI
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bni_internet_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-if="order.payment_log.va_bank_code === 'BRI' || order.payment_log.va_bank_code === 'bri'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bri_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Mobile Banking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bri_mobile_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Internet Banking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bri_internet_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-if="order.payment_log.va_bank_code === 'PERMATA' || order.payment_log.va_bank_code === 'permata'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM PRIMA / ALTO:
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('prima_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Permata Mobile X
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('permata_mobile_x_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Permata Mobile
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('permata_mobile_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Internet Banking Permata (PermataNet)
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('permata_ib_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-if="order.payment_log.va_bank_code === 'BCA' || order.payment_log.va_bank_code === 'bca'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bca_atm_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    IBanking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bca_internet_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    BCA M-Mobile
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li v-for="(item, index) in $t('bca_mobile_banking_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
            </v-expansion-panels>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-btn color="primary" x-large block class="text-none" @click="goToOrder(order.id)">
          {{ $t('view_your_order') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn class="transparent" text fab x-small dark @click="snackbar.show = false">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      order: {},
      timerInterval: null,
      distance: 0,
      expiry_time: '',
      snackbar: {
        show: false,
        text: ''
      }
    }
  },
  computed: {
    formattedTimeLeft() {
      let days = Math.floor(this.distance / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
      let result
      if (this.distance < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' Hari : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ' Jam : ' : hours + ' Jam : '
        minutes = minutes < 10 ? '0' + minutes + ' Menit : ' : minutes + ' Menit : '
        seconds = seconds < 10 ? '0' + seconds + ' Detik' : seconds + ' Detik'
        result = days + hours + minutes + seconds
      }
      return result
    },
    isTMII() {
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain
      if (tmii_outlet.indexOf(url_id) !== -1) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))) {
      this.order = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))
      const time = this.order.payment_log.expired_at
      this.getExpiryTime(time)
    } else {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    }

    if (this.$store.state.selected_type === 'RESERVATION') {
      this.$store.dispatch('removeDataCartReservation')
    } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
      this.$store.dispatch('removeDataCartTakeAway')
    } else if (this.$store.state.selected_type === 'DELIVERY') {
      this.$store.dispatch('removeDataCartDelivery')
    } else if (this.$store.state.selected_type === 'DINE-IN') {
      this.$store.dispatch('removeDataCartDineIn')
    }
  },
  methods: {
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.distance = countDownDate - now
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    },
    goToOrder(id) {
      this.$router.push({ name: 'order', params: { id: id }}).catch(() => {})
      this.$store.dispatch('remove_order')
    },
    copyText() {
      const testingCodeToCopy = document.querySelector('#va_account_number')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()
      try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        this.snackbar.show = true
        this.snackbar.text = 'Number was copied ' + msg
      } catch (err) {
        this.snackbar.show = true
        this.snackbar.text = 'Oops, unable to copy'
      }
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    }
  }
}
</script>
